// extracted by mini-css-extract-plugin
export var arrow = "NewsBanner-module--arrow--d6603";
export var banner = "NewsBanner-module--banner--4d356";
export var link = "NewsBanner-module--link--597fa";
export var logo = "NewsBanner-module--logo--d57ad";